'use client'

import { useMemo } from 'react'
import { IconCheck } from '@tabler/icons-react'
import clsx from 'clsx'

import { ValueOf } from 'shared/types/generic'

import styles from './CheckoutProgressBarItem.module.scss'

const CartProgressBarItemState = {
  active: 'active',
  completed: 'completed',
  inactive: 'inactive'
} as const

type CartProgressBarItemState = ValueOf<typeof CartProgressBarItemState>

interface CheckoutProgressBarItemProps {
  onClick: () => void
  label: string
  stepNumber: number
  activeStep: number
}

const CheckoutProgressBarItem = ({
  onClick,
  label,
  stepNumber,
  activeStep
}: CheckoutProgressBarItemProps) => {
  const state = useMemo(
    () =>
      activeStep === stepNumber
        ? CartProgressBarItemState.active
        : activeStep > stepNumber
          ? CartProgressBarItemState.completed
          : CartProgressBarItemState.inactive,

    [activeStep, stepNumber]
  )

  const isPaymentStep = useMemo(() => stepNumber === 3, [stepNumber])

  const barNumberStateClass = {
    [CartProgressBarItemState.active]: styles.barNumberActive,
    [CartProgressBarItemState.completed]: styles.barNumberCompleted,
    [CartProgressBarItemState.inactive]: styles.barNumberInactive
  }[state]

  return (
    <button
      className={clsx(styles.barItem, {
        [styles.barItemActive]: state === CartProgressBarItemState.active,
        [styles.barItemNoPointer]:
          isPaymentStep || state === CartProgressBarItemState.active
      })}
      onClick={onClick}
      aria-current={
        state === CartProgressBarItemState.active ? 'step' : undefined
      }
      aria-label={label}
    >
      <div className={clsx(styles.barNumber, barNumberStateClass)}>
        {state === CartProgressBarItemState.completed ? (
          <IconCheck />
        ) : (
          stepNumber
        )}
      </div>
      <div
        className={clsx(styles.barTitle, {
          [styles.barTitleActive]: state === CartProgressBarItemState.active
        })}
      >
        {label}
      </div>
    </button>
  )
}

export default CheckoutProgressBarItem
